import styled from "styled-components";

export const PayrollBonusProvidedContainer = styled.div`
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px 0 32px 0;
  h1{
    padding: 0 32px 0 32px;
    font-size: 19px;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0.4px;
    text-align: left;
    color: ${({theme}) => theme.black}
  }
  section{
    padding: 32px;
  }
`

export const NotifyEorContainer = styled.div`
  padding: 0 32px 0 0;
  width: 100%;
  display: flex;
  justify-content: end;
`
